/**
 * Delivery Date Calculator
 * Calculates delivery date 48 hours from current time
 */

class DeliveryCalculator {
  constructor() {
    this.deliveryHours = 48; // 48 hours delivery
    this.init();
  }

  init() {
    const deliveryElements = document.querySelectorAll('[data-delivery-date]');
    deliveryElements.forEach(element => {
      const deliveryDate = this.calculateDeliveryDate();
      element.textContent = deliveryDate;
    });
  }

  calculateDeliveryDate() {
    const now = new Date();
    const deliveryTime = new Date(now.getTime() + (this.deliveryHours * 60 * 60 * 1000));

    // Skip weekends — push to Monday
    const day = deliveryTime.getDay();
    if (day === 0) { // Sunday → Monday
      deliveryTime.setDate(deliveryTime.getDate() + 1);
    } else if (day === 6) { // Saturday → Monday
      deliveryTime.setDate(deliveryTime.getDate() + 2);
    }

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = weekdays[deliveryTime.getDay()];

    return dayName;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DeliveryCalculator();
  });
} else {
  new DeliveryCalculator();
}